@if (loading()) {
<div class="loader">
  <div class="wiper"></div>
</div>
} @else if (error()) {
<p>{{ error() }}</p>
} @else {
<ng-content></ng-content>
}
